import React from "react";
import { Box, Typography, CardMedia, Grid } from "@mui/material";
import ImagenNotFound from "../../../images/Imagen_not_found.png";
import { useTheme } from "@emotion/react";
import AddBoxIcon from "@mui/icons-material/AddBox";
import RemoveBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import DeleteIcon from "@mui/icons-material/Delete";

export const ArticuloKiosk = ({
  productos,
  handleDelete,
  handleIncrease,
  handleDecrease,
  handleClickImg,
}) => {
  const theme = useTheme();
  return (
    <Grid container spacing={2}>
      {productos.map((item, idx) => {
        const descripcion = item.descripcion;
        const quantity = item.cantidadArticulo;
        const precio = item.precioUnitario || item.precioPublico || 0;
        const imageSource = item.imagenBase64 || item.imagen;
        const idProducto = item.idProducto || item.idArticulo;
        const idProductoArray = item.idProductoArray;

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "grid",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#FFFFFF",
              borderRadius: "4px",
              p: 2,
              margin: 0.5,
              width: "95%",
              height: "auto",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Box
              sx={{
                display: "flex",
              }}
            >
              {/* Imagen */}
              <CardMedia
                key={idProducto}
                component="img"
                image={imageSource || ImagenNotFound}
                onClick={() => handleClickImg(imageSource, descripcion)}
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  objectFit: "contain",
                  backgroundColor: "#fff",
                }}
              />
              <Typography
                fontSize={15}
                color="textSecondary"
                sx={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  ml: 2,
                }}
              >
                {descripcion}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontWeight: "bold", fontSize: 15, mr: 2 }}>
                  {quantity <= 1
                    ? `$${precio.toLocaleString("es-Ar")}`
                    : `$${(precio * quantity).toLocaleString("es-Ar")}`}
                </Typography>
                <RemoveBoxIcon
                  sx={{
                    fontSize: 30,
                    color:
                      quantity === 1
                        ? "darkgray"
                        : theme.bandera.colorSecundario,
                  }}
                  onClick={() => quantity > 1 && handleDecrease(idProductoArray)}
                  disabled={quantity === 1}
                />
                <Typography fontSize={15} sx={{ mx: 1 }}>
                  {quantity}
                </Typography>
                <AddBoxIcon
                  sx={{
                    fontSize: 30,
                    mr: 1,
                    color: theme.bandera.colorSecundario,
                  }}
                  onClick={() => handleIncrease(idProductoArray)}
                />

                <DeleteIcon
                  sx={{
                    fontSize: 30,
                    color:
                      quantity === 0
                        ? "darkgray"
                        : theme.bandera.colorSecundario,
                  }}
                  onClick={() => handleDelete(idProductoArray, descripcion)}
                  disabled={quantity === 0}
                />
              </Box>
            </Box>
          </Box>
        );
      })}
    </Grid>
  );
};
